export default "/images/vendor/@coreui/icons/svg/flag/cif-kn.svg?27baf81912e4311fa984aabab399755b";